<button [ngClass]="[style]" [disabled]="disabled" (mouseup.left)="click.emit($event)">
	@if (label) {
		{{ label }}
	}
	<ng-content></ng-content>
	@if (loading) {
		<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'"></cpi-dot-bounce-loading-effect>
	}
</button>
